<template>
  <div class="user">
    <h2 class="project-subtitle">{{ Translator('soprasolar.claim_request.user.title') }}</h2>
    <p>
      {{ Translator('soprasolar.claim_request.step0.form.company') }} :
      <strong>{{ datas.step0.company }}</strong>
    </p>
    <p>
      {{ Translator('soprasolar.claim_request.step0.form.first_name') }} :
      <strong>{{ datas.step0.firstName }}</strong>
    </p>
    <p>
      {{ Translator('soprasolar.claim_request.step0.form.last_name') }} :
      <strong>{{ datas.step0.lastName }}</strong>
    </p>
    <p>
      {{ Translator('soprasolar.claim_request.step0.form.email') }} :
      <strong>{{ datas.step0.email }}</strong>
    </p>
    <p>
      {{ Translator('soprasolar.claim_request.step0.form.phone_number') }} :
      <strong>{{ datas.step0.phoneNumber }}</strong>
    </p>
  </div>
</template>
<style scoped lang="scss">
  @import "~@/soprasolar-claim/assets/styles/import";
  .user {
    width: 100%;
    border: rem(1) solid $grey-light;
    padding: rem(20) rem(30);
    border-radius: rem(8);
    margin-bottom: rem(30);
  }
</style>
<script>
import AppControlService from '@/soprasolar-claim/services/AppControl';

export default {
  name: 'user',
  components: {},
  data () {
    return {
      datas: AppControlService.datas
    }
  },

  created() {},

  beforeDestroy() {},

  mounted() {},

  methods: {

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },
  }
}
</script>